'use client';

import { useEffect, useState, type ComponentType } from 'react';
import { useLoadOnVisible } from '@/components/pages/use-load-on-visible';
import { SlideServer } from './server';
import type { HistoryProps } from '../type';

export default function LazySlideClient(props: HistoryProps) {
  const { ref, shouldLoad } = useLoadOnVisible<HTMLDivElement>();
  const [Client, setClient] = useState<ComponentType<HistoryProps> | null>(null);

  useEffect(() => {
    if (!shouldLoad || Client) return;
    import('./client').then((module) => setClient(() => module.default));
  }, [Client, shouldLoad]);

  return <div ref={ref}>{Client ? <Client {...props} /> : <SlideServer {...props} />}</div>;
}
